import { render, staticRenderFns } from "./ManagementMain.vue?vue&type=template&id=0d866ef4&scoped=true"
import script from "./ManagementMain.vue?vue&type=script&lang=js"
export * from "./ManagementMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d866ef4",
  null
  
)

export default component.exports